// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__ikDH0","noInteraction":"EventWrapper_noInteraction__1ArPW"};